<template>
  <iColumn
    height="hug"
    :min-height="getOptionValue(MinHeight)"
    gap="small"
    align="center"
    :theme-mode="roomThemeMode"
    :data-room-theme-mode="roomThemeMode"
    :style-overrides="{
      paddingTop: 'small',
      paddingBottom: 'small',
      paddingLeft: 'small',
      paddingRight: 'small',
    }"
  >
    <EventRoomPlaceholder :preview-state="previewState" :chrome="roomChrome" />
  </iColumn>
</template>

<script>
import { mapActions, mapState } from "pinia";
import AppearanceOptions from "%/dynamic-component-editor/bundles/appearance-options";
import BackgroundOptions from "%/dynamic-component-editor/bundles/background-options";
import LayoutWidthHeightOptions from "%/dynamic-component-editor/bundles/layout-width-height-options";
import SpacingOptions from "%/dynamic-component-editor/bundles/spacing-options";
import PositioningOptions from "%/dynamic-component-editor/bundles/positioning-options";
import MinHeight from "%/dynamic-component-editor/options/min-height";
import EventRoomOptions from "%/dynamic-component-editor/bundles/event-room-options";
import RoomTheme, { ROOM_THEME_MODES } from "%/dynamic-component-editor/options/room-theme";
import ShowEventTitle from "%/dynamic-component-editor/options/show-event-title";
import ShowElapsedTimer from "%/dynamic-component-editor/options/show-elapsed-timer";
import ShowLiveBadge from "%/dynamic-component-editor/options/show-live-badge";
import ShowViewerCount from "%/dynamic-component-editor/options/show-viewer-count";
import ShowStatusChip from "%/dynamic-component-editor/options/show-status-chip";
import { readRoomToggle } from "%/apps/video-engine/room-appearance";
import EventRoomPlaceholder from "%/dynamic-component-editor/standard-pages/event-page/EventRoomPlaceholder.vue";
import { useEventRoomPreviewStore } from "%/dynamic-component-editor/stores/event-room-preview-store";
import { ROOM_PREVIEW_LIVE } from "%/dynamic-component-editor/helpers/event-room-preview-states";
import { EventCardElementMixin } from "%/dynamic-component-editor/standard-components/event-card/event-card-element-mixin";

const ROOM_MIN_HEIGHT = 300;

// The one element for the whole room lifecycle; EventLiveStream, EventStartsAt
// and EarlyAccessAt alias onto it (helpers/deprecated-element-type-aliases.js).
export default {
  name: "EventVideoRoom",
  components: {
    EventRoomPlaceholder,
  },
  mixins: [EventCardElementMixin],
  elementPanelSettings: {
    displayName: "Event Video Room",
    displayIcon: "video",
    elementGroup: "eventElements",
    elementType: "element",
  },
  data() {
    return {
      MinHeight,
    };
  },
  computed: {
    ...mapState(useEventRoomPreviewStore, ["previewState"]),
    callOnlyChrome() {
      return [this.roomChrome.showEventTitle, this.roomChrome.showElapsedTimer, this.roomChrome.showLiveBadge].join("|");
    },
    roomThemeMode() {
      return ROOM_THEME_MODES[this.getOptionValue(RoomTheme)] || ROOM_THEME_MODES.match;
    },
    roomChrome() {
      return {
        showEventTitle: readRoomToggle(this, ShowEventTitle),
        showElapsedTimer: readRoomToggle(this, ShowElapsedTimer),
        showLiveBadge: readRoomToggle(this, ShowLiveBadge),
        showViewerCount: readRoomToggle(this, ShowViewerCount),
        showStatusChip: readRoomToggle(this, ShowStatusChip),
      };
    },
  },
  watch: {
    callOnlyChrome() {
      if (this.previewState !== ROOM_PREVIEW_LIVE) {
        this.setPreviewState(ROOM_PREVIEW_LIVE);
      }
    },
  },
  methods: {
    ...mapActions(useEventRoomPreviewStore, ["setPreviewState"]),
  },
  optionBundles: [
    PositioningOptions,
    new AppearanceOptions({ "default.border-radius": "large" }, { "border-radius": false }),
    // min-height must come through the bundle: LayoutWidthHeightOptions carries
    // its own MinHeight, which shadows a standalone one and drops its default.
    new LayoutWidthHeightOptions({ "default.min-height": ROOM_MIN_HEIGHT }, {
      "max-width": true,
      "max-height": true,
      "min-width": true,
    }),
    new SpacingOptions(),
    new BackgroundOptions({
      "default.background-color": "none",
    }, { "background-gradient": true }),
    new EventRoomOptions(),
  ],
};
</script>
